import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforpicnic() {

const cardData = {
keyword: "Urbania Hire for Picnic in Pune",
headingDescription: "Urbania Hire for Picnic in Pune is a convenient group transportation option for families, schools, colleges, corporate teams, friends, and social groups planning one-day or outstation picnic trips. Ruturaj Enterprises provides Urbania vehicles in multiple seating capacities, making it easier for groups to travel together with comfortable seating, useful luggage space, and professional driver assistance. Whether the destination is a nearby picnic spot around Pune or a longer outstation location, a dedicated Urbania helps simplify pickup, route planning, group coordination, and return travel.",
topPlaces: [
{
title: "Pawna Lake",
description: "Pawna Lake is a popular destination for camping, nature outings, family gatherings, and group picnics near Pune. An Urbania provides a convenient way for larger groups to travel together with picnic supplies, bags, and other belongings while enjoying a coordinated road journey."
},
{
title: "Lonavala",
description: "Lonavala is a practical choice for one-day picnics, family outings, school trips, and corporate group activities. Travelling by Urbania allows the entire group to stay together while visiting viewpoints, waterfalls, lakes, and other attractions around the hill station."
},
{
title: "Kamshet",
description: "Kamshet offers a combination of scenic landscapes, lakes, and outdoor activities that make it suitable for group picnics and weekend outings. A private Urbania provides comfortable transportation for families, friends, students, and corporate teams travelling from Pune."
},
{
title: "Mulshi",
description: "Mulshi is known for its greenery, hills, and lakeside surroundings and is frequently selected for peaceful day trips from Pune. Groups can use an Urbania to carry picnic equipment and travel together without having to arrange multiple smaller vehicles."
},
{
title: "Khadakwasla Dam",
description: "Khadakwasla is a convenient nearby destination for short family outings, student picnics, and casual group trips. An Urbania can accommodate larger parties and provide an organized pickup and drop arrangement for a relaxed one-day picnic."
},
{
title: "Sinhagad Fort",
description: "Sinhagad is a popular destination for educational trips, family outings, trekking groups, and college picnics. Travelling together in an Urbania makes it easier to coordinate the group's journey from Pune and manage belongings during the day trip."
},
{
title: "Panshet Dam",
description: "Panshet is surrounded by hills and water bodies, making it suitable for nature-focused picnics and group recreation. A spacious Urbania can transport families, friends, students, or corporate teams together while providing room for picnic bags and other essentials."
},
{
title: "Matheran",
description: "Matheran is a popular hill destination for family holidays, school groups, college outings, and corporate leisure trips. Urbania transportation can be arranged from Pune for the road journey, allowing larger groups to coordinate their travel and return schedule."
},
{
title: "Mahabaleshwar",
description: "Mahabaleshwar is well suited for longer picnic tours involving viewpoints, nature attractions, and family activities. A private Urbania gives larger groups a comfortable way to travel from Pune with luggage and enjoy a planned one-day or extended outing."
},
{
title: "Alibaug",
description: "Alibaug is a popular coastal destination for group outings, family picnics, college trips, and corporate leisure programs. Groups travelling from Pune can use an Urbania for a coordinated road journey with convenient seating and space for personal belongings."
}
],
services: [
{
name: "Urbania on Rent for Picnic Pune",
description: "Urbania on rent for picnic trips from Pune provides a spacious group vehicle for families, students, friends, and organizations. It is suitable for nearby picnic spots as well as longer outstation outings where passengers want to travel together."
},
{
name: "Urbania Hire for Picnic Pune",
description: "Urbania hire for picnic travel offers a dedicated vehicle for organized group outings, making pickup and drop arrangements easier. The service can be planned around the number of passengers, picnic destination, trip duration, and preferred departure time."
},
{
name: "Urbania Booking for Picnic Pune",
description: "Urbania booking for picnic trips allows groups to arrange their vehicle in advance for school outings, family gatherings, corporate picnics, college trips, and one-day tours. Advance booking helps match the seating capacity with the group size."
},
{
name: "Urbania Traveller for Picnic Pune",
description: "Urbania Traveller transportation is suitable for groups that want to remain together during a picnic journey. The spacious interior provides a practical setup for passengers travelling with bags, food, recreation equipment, and other picnic essentials."
},
{
name: "Urbania Van Rental for Picnic Pune",
description: "Urbania van rental for picnics gives larger groups a comfortable alternative to arranging several cars. It can be used for local Pune outings, nearby nature destinations, school trips, corporate activities, and longer outstation picnic tours."
},
{
name: "13 Seater Urbania for Picnic Pune",
description: "13 Seater Urbania is suitable for smaller families, friend groups, and compact picnic parties. The vehicle allows the group to travel together while providing useful space for bags and picnic materials during a one-day or outstation outing."
},
{
name: "14 Seater Urbania for Picnic Pune",
description: "14 Seater Urbania provides a convenient seating arrangement for medium-sized picnic groups. It can be used for family outings, school activities, college trips, corporate picnics, and recreational tours from Pune to nearby destinations."
},
{
name: "17 Seater Urbania for Picnic Pune",
description: "17 Seater Urbania is a practical choice for larger families, student groups, corporate teams, and friends planning a picnic together. Its higher passenger capacity helps keep the group in one vehicle while making travel coordination easier."
},
{
name: "20 Seater Urbania for Picnic Pune",
description: "20 Seater Urbania is designed for larger picnic groups requiring higher passenger capacity. It can be arranged for school and college outings, corporate picnics, social groups, family gatherings, and organized day tours from Pune."
},
{
name: "Luxury Urbania for Picnic Pune",
description: "Luxury Urbania for picnic travel provides a more premium and spacious environment for groups who want additional comfort during their outing. It is suitable for corporate teams, families, special gatherings, and longer journeys where comfortable travel is important."
},
{
name: "Urbania for Family Picnic Pune",
description: "Urbania for family picnics gives relatives and different age groups the convenience of travelling together. Families can carry food, bags, children's items, and other belongings while enjoying a coordinated journey to their chosen picnic destination."
},
{
name: "Urbania for Group Picnic Pune",
description: "Urbania for group picnics is suitable for friends, community groups, clubs, and social gatherings. A single dedicated vehicle helps simplify passenger coordination, pickup arrangements, route planning, and return travel after the outing."
},
{
name: "Urbania for School Picnic Pune",
description: "Urbania for school picnics provides group transportation for educational outings and recreational school trips. Schools can select an appropriate seating capacity based on the number of students and accompanying teachers while keeping the group together during travel."
},
{
name: "Urbania for College Picnic Pune",
description: "Urbania for college picnics is suitable for student groups travelling to nearby attractions, adventure destinations, hill stations, and recreational locations. Shared transportation makes it easier to coordinate departure, sightseeing, meal stops, and the return journey."
},
{
name: "Urbania for Corporate Picnic Pune",
description: "Urbania for corporate picnics offers organized transportation for employees attending team outings, annual gatherings, recreational programs, and company events. A dedicated vehicle helps teams travel together between the office, destination, and planned activity locations."
},
{
name: "Urbania for One Day Picnic Pune",
description: "Urbania for one-day picnics is suitable for groups looking for an early departure and same-day return from Pune. The itinerary can be planned around the destination, activity schedule, meal breaks, sightseeing requirements, and preferred return time."
},
{
name: "Urbania for Picnic Outstation Pune",
description: "Urbania for picnic outstation travel from Pune is suitable for groups visiting destinations outside the city for a full-day or extended outing. It provides shared transportation for families, students, employees, friends, and organized groups."
},
{
name: "Urbania Traveller Hire for Picnic Pune",
description: "Urbania Traveller hire for picnic trips provides a dedicated group vehicle with professional driver assistance. It can be arranged according to passenger count and used for family outings, corporate programs, student trips, or leisure travel."
},
{
name: "Urbania for Picnic Tour Pune",
description: "Urbania for picnic tours can be arranged for destinations around Pune and longer routes across Maharashtra. Groups can customize the itinerary with sightseeing stops, activity locations, meal breaks, and a convenient return schedule."
},
{
name: "Affordable Urbania for Picnic Pune",
description: "Affordable Urbania for picnic travel offers groups a practical way to share transportation costs while travelling together. Choosing a vehicle according to the actual passenger count can help maintain a comfortable and economical arrangement for the outing."
}
],
tableData: [
["Urbania on Rent for Picnic Pune"],
["Urbania Hire for Picnic Pune"],
["Urbania Booking for Picnic Pune"],
["Urbania Traveller for Picnic Pune"],
["Urbania Van Rental for Picnic Pune"],
["13 Seater Urbania for Picnic Pune"],
["14 Seater Urbania for Picnic Pune"],
["17 Seater Urbania for Picnic Pune"],
["20 Seater Urbania for Picnic Pune"],
["Luxury Urbania for Picnic Pune"],
["Urbania for Family Picnic Pune"],
["Urbania for Group Picnic Pune"],
["Urbania for School Picnic Pune"],
["Urbania for College Picnic Pune"],
["Urbania for Corporate Picnic Pune"],
["Urbania for One Day Picnic Pune"],
["Urbania for Picnic Outstation Pune"],
["Urbania Traveller Hire for Picnic Pune"],
["Urbania for Picnic Tour Pune"],
["Affordable Urbania for Picnic Pune"]
],
whychoose: [
{
WhyChooseheading: "Spacious Travel for Picnic Groups",
WhyChoosedescription: "Picnic groups often carry food, bags, activity equipment, and personal belongings along with passengers. Urbania provides a spacious group transportation setup that helps everyone travel together without needing several separate cars."
},
{
WhyChooseheading: "Different Seating Capacities",
WhyChoosedescription: "Picnic parties can vary considerably in size, from small family groups to large school or corporate teams. Multiple Urbania seating options make it easier to choose a vehicle that matches the number of passengers and luggage requirements."
},
{
WhyChooseheading: "Convenient for One-Day Outings",
WhyChoosedescription: "A dedicated Urbania is well suited for one-day picnic plans where groups leave Pune in the morning and return after completing their activities. Pickup and drop arrangements can be coordinated according to the planned itinerary."
},
{
WhyChooseheading: "Suitable for Schools and Colleges",
WhyChoosedescription: "Educational institutions can use Urbania for organized student outings, recreational trips, and educational visits. Keeping students and accompanying staff together helps simplify transportation planning throughout the day's itinerary."
},
{
WhyChooseheading: "Useful for Corporate Picnics",
WhyChoosedescription: "Corporate teams can use Urbania transportation for employee picnics, team-building outings, annual gatherings, and recreational events. Shared travel makes group coordination easier while providing a comfortable journey to and from the destination."
},
{
WhyChooseheading: "Comfortable for Family Outings",
WhyChoosedescription: "Family picnics may include children, adults, and senior family members travelling together. A spacious Urbania allows everyone to share one vehicle and makes it easier to carry the additional belongings commonly needed for a full-day outing."
},
{
WhyChooseheading: "Suitable for Nearby and Outstation Destinations",
WhyChoosedescription: "The same group travel arrangement can be used for destinations close to Pune as well as longer outstation picnic routes. Groups can plan visits to lakes, hill stations, forts, nature destinations, and other recreational locations."
},
{
WhyChooseheading: "Professional Driver Assistance",
WhyChoosedescription: "Driver-assisted travel lets the group focus on enjoying the picnic instead of managing highway driving and navigation. This is particularly useful for larger groups travelling to unfamiliar destinations or planning multiple stops during the outing."
}
]
};











const faqData = [
{
question: "How can I hire an Urbania for a picnic in Pune?",
answer: "Groups planning a picnic can enquire about an Urbania by sharing the pickup location, picnic destination, travel date, passenger count, departure time, and expected return schedule. Ruturaj Enterprises can discuss the transportation arrangement according to the group's planned picnic itinerary."
},
{
question: "Why is an Urbania suitable for a group picnic in Pune?",
answer: "An Urbania can be considered when a larger group wants to travel together for a picnic without arranging multiple smaller vehicles. It is useful for families, friends, school groups, office teams, college students, and social organizations planning a shared day trip."
},
{
question: "Can I hire an Urbania for a one-day picnic from Pune?",
answer: "Groups can arrange an Urbania for a same-day picnic from Pune to a selected destination and return after completing the day's activities. The schedule can be planned around the preferred departure time, picnic location, meal breaks, activities, and expected return time."
},
{
question: "Which destinations can I visit by Urbania for a picnic from Pune?",
answer: "An Urbania can be used for group picnic trips to destinations around Pune and nearby areas, depending on the group's preferred route. Places such as Lonavala, Khandala, Mulshi, Lavasa, Mahabaleshwar, Panchgani, and other suitable picnic locations can be considered for the itinerary."
},
{
question: "Can families hire an Urbania for a picnic in Pune?",
answer: "Families can consider an Urbania for reunions, weekend outings, birthday celebrations, and casual picnic trips. Keeping the group together in one vehicle can make it easier to coordinate pickup points, travel breaks, activities, and the return journey."
},
{
question: "Can companies hire an Urbania for a picnic or team outing in Pune?",
answer: "Corporate teams can arrange an Urbania for employee picnics, team outings, recreational programs, and informal company trips. The transportation schedule can be coordinated with the office pickup points, picnic venue, activity timings, meal breaks, and return plan."
},
{
question: "Is Urbania available for school and college picnic trips?",
answer: "Schools, colleges, and educational groups can enquire about an Urbania for picnics, recreational outings, educational visits, and student group programs. The travel plan can be discussed according to the number of passengers, destination, reporting time, planned activities, and return schedule."
},
{
question: "Can I use an Urbania for an outstation picnic from Pune?",
answer: "Groups planning a picnic outside Pune can discuss an Urbania rental for destinations such as Mahabaleshwar, Panchgani, Malshej Ghat, Nashik, or other locations based on the preferred route. The rental schedule can cover the journey, local movements, and return travel."
},
{
question: "Can an Urbania be used for a picnic with multiple pickup points in Pune?",
answer: "When group members are located in different parts of Pune, multiple pickup points can be discussed while planning the journey. Sharing the pickup locations, passenger count, reporting time, and final destination with Ruturaj Enterprises helps in coordinating the picnic transportation schedule."
},
{
question: "What details are required to book an Urbania for a picnic?",
answer: "Customers can provide the picnic date, Pune pickup location or multiple pickup points, destination, passenger count, departure time, expected trip duration, activity schedule, and return requirements. Ruturaj Enterprises can use these details to discuss the Urbania rental arrangement for the group."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Akash Pawar",
feedback:
"Our office team planned a one-day picnic from Pune and needed transportation for everyone in one vehicle. We hired an Urbania from Ruturaj Enterprises and shared the pickup points and activity schedule beforehand. The group travel arrangement made it easier to keep everyone together throughout the outing.",
rating: 5
},
{
id: 2,
name: "Miss. Snehal Patil",
feedback:
"We organized a family picnic near Pune with relatives coming from different areas of the city. Ruturaj Enterprises arranged an Urbania according to our pickup plan, and everyone could travel together to the picnic location. The common vehicle made the day's travel and return arrangements much simpler.",
rating: 5
}
];









































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Picnic in Pune",
  "image": "https://ruturajenterprises.com/assets/images/urbania-hire-for-picnic-in-pune.webp",
  "description": "Urbania Hire for Picnic in Pune from Ruturaj Enterprises is a spacious group transportation option for families, friends, schools, colleges, corporate teams and larger groups planning a comfortable picnic or day outing. Urbania on Rent for Picnic Pune, Urbania Hire for Picnic Pune and Urbania Booking for Picnic Pune are suitable for organized local and outstation picnic travel where the entire group can travel together in one dedicated vehicle. Urbania Traveller for Picnic Pune and Urbania Van Rental for Picnic Pune provide convenient transportation for different group sizes, while 13 Seater Urbania for Picnic Pune, 14 Seater Urbania for Picnic Pune, 17 Seater Urbania for Picnic Pune and 20 Seater Urbania for Picnic Pune allow passengers to select a suitable vehicle according to the number of travellers. Luxury Urbania for Picnic Pune provides a spacious option for groups looking for added comfort during their journey. Urbania for Family Picnic Pune and Urbania for Group Picnic Pune are suitable for family outings, friends' gatherings and recreational trips. Urbania for School Picnic Pune and Urbania for College Picnic Pune can accommodate student groups and staff travelling together for planned educational or recreational outings. Urbania for Corporate Picnic Pune is useful for employee outings, team activities and company-organized day trips. Urbania for One Day Picnic Pune can be arranged for short-duration sightseeing and leisure journeys, while Urbania for Picnic Outstation Pune supports trips to destinations outside Pune. Urbania Traveller Hire for Picnic Pune and Urbania for Picnic Tour Pune provide flexible group transportation for planned itineraries, sightseeing stops and return journeys. Affordable Urbania for Picnic Pune offers a practical solution for groups that want to share transportation costs while travelling comfortably together.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/urbania-hire-for-picnic-in-pune"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Urbania Hire for Picnic in Pune | 13, 14, 17 & 20 Seater Traveller for Group Outings | +91 9763381382
  </title>

  <meta
    name="description"
    content="Urbania Hire for Picnic in Pune by Ruturaj Enterprises for family, school, college and corporate picnics with 13, 14, 17 and 20 seater Urbania options."
  />

  <meta
    name="keywords"
    content="Urbania Hire for Picnic in Pune, Urbania on Rent for Picnic Pune, Urbania Hire for Picnic Pune, Urbania Booking for Picnic Pune, Urbania Traveller for Picnic Pune, Urbania Van Rental for Picnic Pune, 13 Seater Urbania for Picnic Pune, 14 Seater Urbania for Picnic Pune, 17 Seater Urbania for Picnic Pune, 20 Seater Urbania for Picnic Pune, Luxury Urbania for Picnic Pune, Urbania for Family Picnic Pune, Urbania for Group Picnic Pune, Urbania for School Picnic Pune, Urbania for College Picnic Pune, Urbania for Corporate Picnic Pune, Urbania for One Day Picnic Pune, Urbania for Picnic Outstation Pune, Urbania Traveller Hire for Picnic Pune, Urbania for Picnic Tour Pune, Affordable Urbania for Picnic Pune, Urbania Picnic Vehicle Pune, Urbania Picnic Rental with Driver Pune, Urbania for Family Outing Pune, Urbania for Group Outing Pune, Urbania for School Trip Pune, Urbania for College Trip Pune, Urbania for Corporate Outing Pune, Urbania for Team Outing Pune, Urbania for One Day Tour Pune, Urbania for Day Trip Pune, Urbania Outstation Picnic Traveller Pune, Luxury Urbania Picnic Rental Pune, AC Urbania for Picnic Pune, Urbania Group Transportation Pune, Urbania for Weekend Picnic Pune, Urbania Rental Near Me for Picnic Pune, Urbania Traveller for Day Out Pune, Pune Picnic Group Traveller, Pune Picnic Tour Vehicle"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/115.png' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforpicnic;